/**
 * Client-side filtering for profile "last N sales" — mirrors functions/v2/httpprofile.js
 * hitMatchesSalesFilter / populationTypeFromSaleSource for list-item shape.
 */

export function populationTypeFromProfileSaleItem(item, supportsAutographPopulation = false) {
  if (item.hasAutographGrade && supportsAutographPopulation) return 'autograph';
  if (item.hasQualifier) return 'qualifier';
  return 'base';
}

export function profileSaleMatchesSelection(item, grader, grade, populationType, supportsAutographPopulation = false) {
  if (!grader || grade === undefined || grade === null || grade === '') return false;
  const pop = populationType || 'base';
  if ((item.grader || '').toLowerCase() !== (grader || '').toLowerCase()) return false;
  if (String(item.grade) !== String(grade)) return false;
  return populationTypeFromProfileSaleItem(item, supportsAutographPopulation) === pop;
}

/**
 * @param {object[]} sales - Newest-first (same order as httpprofile Elasticsearch sort).
 */
export function filterProfileSalesForSelection(
  sales,
  grader,
  grade,
  populationType,
  limit = 5,
  supportsAutographPopulation = false,
) {
  if (!Array.isArray(sales) || !sales.length) return [];
  const out = [];
  for (let i = 0; i < sales.length && out.length < limit; i += 1) {
    if (profileSaleMatchesSelection(sales[i], grader, grade, populationType, supportsAutographPopulation)) {
      out.push(sales[i]);
    }
  }
  return out;
}
